module.exports = __webpack_public_path__ + "img/14.e28bcda4.jpg";